export enum ClassTypeCategory {
    GROUP = '66672963d8f4d0d4f3f46546',
    PERFORMANCE = '6667296ad8f4d0d4f3f4654a',
    CHAMPIONSHIP = '66672972d8f4d0d4f3f4654e',
    // ADULT = '6638fe6b59686eb9c0353706',
  }
  